module.exports = __webpack_public_path__ + "static/media/welcome1.6340aa3f.png";